<script>
    import {fly} from 'svelte/transition'
</script>

<div class="container"
    in:fly="{{ y: -50, duration: 250, delay: 300 }}"
    out:fly="{{ y: -50, duration: 250 }}"
    >
  <div class="row horaires">
    <table class="table-primary table-bordered border-primary">
      <thead>
        <tr>
          <td>Jour</td>
          <td>Heures</td>
        </tr>
      </thead>
      <tbody>
        <tr class="bg-success">
          <td colspan="2"><h6>Grand Bassin d'entraînement</h6></td>
        </tr>
        <tr>
          <td colspan="2"><span class="titre1">Période scolaire:</span></td>
        </tr>
        <tr>
          <td><span>Lundi</span></td>
          <td>12h - 13h30 et 17h - 20h </td>
        </tr>
        <tr>
          <td>
            <span class="jour">Mardi :</span>
          </td>
          <td> 12h - 13h30 et 18h - 20h</td>
        </tr>
        <tr>
          <td>
            <span class="jour">Mercredi :</span>
          </td>
          <td> 7h30 - 9h et 14h30 - 20h </td>
        </tr>
        <tr>
          <td><span class="jour">Jeudi :</span></td>
          <td> 7h30 - 9h, 12h - 13h30 et 18h - 20h </td>
        </tr>
        <tr>
          <td>
            <span class="jour">Samedi :</span>
          </td>
          <td> 10h - 12h et 14h - 18h </td>
        </tr>
        <tr>
          <td>
            <span class="jour">Dimanche :</span>
          </td>
          <td> 9h - 13h </td>
        </tr>
        <tr>
          <td colspan="2"><span class="titre2">Vacances scolaires:</span></td>
        </tr>
        <tr>
          <td>
            <span class="jour">Du lundi au vendredi :</span>
          </td>
          <td> 10h - 19h </td>
        </tr>
        <tr>
          <td><span class="jour">Samedi :</span></td>
          <td> 10h - 12h et 14h - 18h </td>
        </tr>
        <tr>
          <td><span class="jour">Dimanche :</span></td>
          <td> 9h - 13h </td>
        </tr>
        <tr class="bg-success">
          <td colspan="2"><h6>Bassin d'entraînement</h6></td>
        </tr>
        <tr>
          <td colspan="2"> <span class="titre1">Période scolaire:</span></td>
        </tr>
        <tr>
          <td><span class="jour">Lundi et vendredi :</span></td>
          <td> 12h - 13h30 </td>
        </tr>
        <tr>
          <td><span class="jour">Mardi et jeudi :</span></td>
          <td> 12h - 13h30 et 18h - 20h </td>
        </tr>
        <tr>
          <td><span class="jour">Mercredi:</span></td>
          <td> 14h30 - 18h </td>
        </tr>
        <tr>
          <td colspan="2"><span class="jour">Fermé Samedi :</span></td>
        </tr>
        <tr>
          <td> <span class="jour">Dimanche :</span></td>
          <td> 9h - 13h </td>
        </tr>
        <tr>
          <td colspan="2"><span class="titre2">Vacances scolaires:</span></td>
        </tr>
        <tr>
          <td><span class="jour">Lundi, mardi, jeudi et vendredi :</span></td>
          <td> 12h - 17h</td>
        </tr>
        <tr>
          <td><span class="jour">Mercredi :</span></td>
          <td> 13h - 17h</td>
        </tr>
        <tr>
          <td> <span class="jour">Samedi</span></td>
          <td> 14h-18h</td>
        </tr>
        <tr>
          <td> <span class="jour">Dimanche :</span></td>
          <td> 9h - 13h</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<style>
  .horaires {
    font-size: 0.75em;
  }
  .titre1 {
    font-weight: bold;
    color: darkcyan;
  }
  .titre2 {
    font-weight: bold;
    color: rgb(238, 80, 209);
  }
  .jour {
    font-weight: bold;
  }
</style>
